import type { ReactElement } from 'react';

import { cn } from '@/lib/cn';
import { BUCKET_TO_TAILWIND, getBucket, type Domain } from '@/lib/status-buckets';
import { getLabel } from '@/lib/status-labels';

interface StatusDotProps {
  domain: Domain;
  state: string;
  showLabel?: boolean;
  className?: string;
}

export const StatusDot = ({
  domain,
  state,
  showLabel = true,
  className,
}: StatusDotProps): ReactElement => {
  const bucket = getBucket(domain, state);
  const label = getLabel(domain, state);
  return (
    <span
      className={cn('inline-flex items-center gap-2', className)}
      aria-label={`${domain}: ${label}`}
      title={`${domain}: ${label}`}
    >
      <span
        className={cn('inline-block h-2 w-2 rounded-full', BUCKET_TO_TAILWIND[bucket])}
        aria-hidden="true"
      />
      {showLabel && <span className="text-sm">{label}</span>}
    </span>
  );
};
